import { useCallback } from "react";

import { useEvent } from "react-use";

import { useWaterlyAppStore } from "../stores";
import { OnlineStatus } from "../stores/slices/onlineStatus.slice";

const OnlineStatusProvider = () => {
  const setOnlineStatus = useWaterlyAppStore((s) => s.setOnlineStatus);

  const onNavigatorEvent = useCallback(
    (evt: Event) => {
      setOnlineStatus(
        evt.type === "online" ? OnlineStatus.online : OnlineStatus.offline,
        `browser updated online status to: ${evt.type}`,
      );
    },
    [setOnlineStatus],
  );

  useEvent("online", onNavigatorEvent);
  useEvent("offline", onNavigatorEvent);

  return null;
};

export default OnlineStatusProvider;
